//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  functionsMainGrid: {
    "@media (max-width: 600px)": {
      overflow: "scroll",
      whiteSpace: "nowrap",
    },
  },
  transactionText: {
    color: "#707070",
    fontSize: 18,
  },
  recordIcon: {
    font: "normal normal normal 0.8vw Segoe-ui",
    color: "#707070",
    margin: "0px 10px",
    verticalAlign: "middle",
  },
  loyaltyIdText: {
    color: "#707070",
    fontSize: 17,
  },
  loyaltyIdCard: {
    // width: 246,
    backgroundColor: "#E4E4E4!important",
    display: "inline-flex",
    borderRadius: "10px!important",
    boxShadow: "none!important",
    marginLeft: 5,
  },
  loyaltyIdResultText: {
    color: "#707070",
    fontSize: 22,
    alignSelf: "center",
    margin: "10px 28px",
    height: 30,
  },
  searchInputContainer: {
    margin: "0px 19px",
  },
  searchInput: {
    // width: 350,
    borderRadius: 0,
  },
  searchInputIcon: {
    fontSize: 24,
    color: "#707070",
  },
  filterBtn: {
    backgroundColor: "#2F7CBD",
    color: "#fff",
    width: 100,
    height: 50,
    borderRadius: 10,
    fontFamily: "Segoe-ui",
    fontSize: 15,
    marginBottom: 29,
    marginTop: 10,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#2F7CBD",
    },
  },
  exportParentDiv: {
    fontSize: 15,
    cursor: "pointer",
  },
  exportDiv: {
    fontFamily: "segoe-ui",
    color: "#ffff",
  },
  popover: {
    fontSize: 40,
    float: "right",
    cursor: "pointer",
    marginTop: "15px",
    marginRight: 20,
    "@media (max-width: 600px)": {
      verticalAlign: "top",
      float: "none",
    },
  },
  filterCardDiv: {
    "@media (max-width: 600px)": {
      overflow: "scroll",
    },
  },
  filterCard: {
    boxShadow: " 10px 10px 10px #00000029 !important",
    border: " 1px solid #707070",
    borderRadius: "20px !important",
    width: 1100,
    height: 145,
    zIndex: 100,
  },
  filterCardGridContainer: {
    padding: 5,
    height: "100%",
  },
  filterCardGrid: {
    borderRight: "1px solid #0000004D",
  },
  filterCardHeadText: {
    fontWeight: "bold",
    fontSize: 24,
  },
  filterCardSubHeadText: {
    fontSize: 24,
  },
  filterCardInput: {
    borderRadius: 10,
  },
  filterCardBtnGrid: {
    textAlign: "center",
    alignSelf: "center",
  },
  filterCardResetBtn: {
    color: "#2F7CBD",
    backgroundColor: "#fff",
    fontSize: 22,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 150,
    height: 45,
    textTransform: "capitalize",
  },
  filterCardApplyBtn: {
    color: "#fff",
    backgroundColor: "#2F7CBD",
    fontSize: 22,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 150,
    height: 45,
    marginTop: "7%",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#2F7CBD",
    },
  },
  badge: {
    backgroundColor: "#C52025",
    color: "#fff",
    fontWeight: "bold",
  },
  tableDiv: {
    overflowY: "auto",
    height: 300,
  },
  tableDiv2: {
    overflowY: "auto",
  },
  tableDivPending: {
    overflowY: "auto",
    height: 250,
    scrollSnapStop: "always",
  },
  emptyDataText: {
    textAlign: "center",
    fontSize: 30,
    fontFamily: "segoe-ui",
    padding: "10%",
    opacity: "0.4",
  },
  emptyDataIcon: {
    fontSize: 30,
  },
  viewMore: {
    textAlign: "center",
    textDecoration: "underline",
    color: "#8f1e5f",
    fontSize: 25,
    padding: 10,
    fontWeight: "bold",
  },
  viewMoreText: {
    cursor: "pointer",
  },
  issuedHeadings: {
    "@media (max-width: 1000px)": {
      width: 125
    }
  },
  nonSalesHeadings: {
    "@media (max-width: 1000px)": {
      width: 140
    }
  },
  earnPendingHeadings: {
    "@media (max-width: 1000px)": {
      width: 125
    }
  },
  redeemedHeadings: {
    "@media (max-width: 1000px)": {
      width: 125
    }
  }
}));

export default useStyles;
